"use strict";

exports.__esModule = true;
exports.default = {
  handleClick: function handleClick(e) {
    e.stopPropagation();
  }
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-json-tree/lib/mixins/squash-click-event.js
 ** module id = 691
 ** module chunks = 0
 **/